import { Suspense } from "react";
import { useTenant } from "../../tenants/useTenant";
import { usePanel } from "./hooks/usePanel";

const Panel = () => {
  const tenant = useTenant();

  const {
    search,
    setSearch,
    staffMemberInfo,
    casesCount,
    refetchCasesCount,
    logout
  } = usePanel({});

  const PanelPage = tenant.panel;
  const hospitalData = tenant.hospital;

  return (
    <Suspense fallback={null}>
      <PanelPage
        search={search}
        setSearch={setSearch}
        staffMemberInfo={staffMemberInfo}
        casesCount={casesCount}
        refetchCasesCount={refetchCasesCount}
        hospitalData={hospitalData}
        logout={logout}
      />
    </Suspense>
  );
};

export default Panel;